module.exports = __webpack_public_path__ + "img/16581250_S.9d4868cb.png";